<template>
  <div>
    <div
      v-for="(section, sectionIndex) in sections"
      :key="sectionIndex + section.title"
      class="section"
    >
      <h2>{{ section.title }}</h2>
      <div class="test-case-container pl-4">
        <h3>
          Test Cases
          <small class="text-red font-normal">* Required test case.</small>
        </h3>
        <small>Check all test cases which pass.</small>
        <div
          v-for="(testCase, testCaseIndex) in section.tests"
          :key="testCase.title + testCaseIndex"
          class="test-case mb-2 p-2"
          :style="
            testCase.passed
              ? 'border: 1px solid #00d925;background: #f9fff9;'
              : 'border: 1px solid #ef8686;background: #fffafa;'
          "
        >
          <h4
            class="title flex items-center justify-start font-normal"
            :style="testCase.passed ? 'color: #008a3b' : 'color: #e3342f'"
          >
            <input
              type="checkbox"
              class="mr-2 checkbox"
              :checked="testCase.passed"
              @click="handleCheckboxClick($event, sectionIndex, testCaseIndex)"
            />
            <span v-if="testCase.is_required" class="text-red mr-1">
              *
            </span>
            {{ testCase.passed ? `(${testCase.points} pts)` : "" }}
            {{ testCase.title }}
          </h4>
          <div class="flex justify-start items-start ml-8">
            <label class="py-0">Your Comment</label>
            <button
              :title="editorIndex === testCaseIndex ? 'Finish' : 'Edit'"
              class="inline-block ml-2 text-xl hover:bg-grey text-center icon"
              style="width: 1.6rem;"
              @click="showEditor(testCaseIndex)"
            >
              <img
                :src="
                  editorIndex === testCaseIndex
                    ? '/images/icons/checkmark.svg'
                    : '/images/icons/your_answer.svg'
                "
              />
            </button>
          </div>
          <QuillEditor
            v-if="editorIndex === testCaseIndex"
            ref="myQuillEditor"
            class="comment-editor w-full"
            :content="testCase.comment"
            :options="quillEditorOptions"
            @input="handleInput($event, sectionIndex, testCaseIndex)"
          />
          <div
            v-else
            class="review-testcase-comment color-primary font-normal ml-2"
            v-html="testCase.comment"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"

export default {
  components: {
    QuillEditor: quillEditor,
  },
  props: {
    testCases: {
      type: Object,
      required: true,
    },
    quillEditorOptions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editorIndex: null,
    }
  },
  computed: {
    sections() {
      return this.testCases ? this.testCases.sections : []
    },
  },
  methods: {
    showEditor(index) {
      if (this.editorIndex === index) {
        this.editorIndex = null
      } else {
        this.editorIndex = index
      }
    },
    handleInput(content, sectionIndex, testCaseIndex) {
      this.$emit("UPDATE_CONTENT", { content, sectionIndex, testCaseIndex })
    },
    handleCheckboxClick(event, sectionIndex, testCaseIndex) {
      this.$emit("UPDATE_TESTCASE_STATUS", {
        passed: event.target.checked,
        sectionIndex,
        testCaseIndex,
      })
    },
  },
}
</script>

<style scoped>
.test-case-container {
  border-left: 2px solid silver;
}

.test-case {
  background: #f3f3f3;
}

.checkbox:focus,
.checkbox:active {
  outline: 2px solid #004e6d;
}

.checkbox::before,
.checkbox:checked:after {
  all: unset;
}

.icon {
  margin: 0;
  margin-left: 0.5rem;
  padding: 0;
  border-radius: 3px;
}

.icon:active,
.icon:focus {
  background: silver;
}

@media screen and (min-width: 640px) {
  .review-testcase-comment {
    padding-left: 1.6rem;
  }
}
</style>

// global styles for quill editor
<style>
.comment-editor .ql-editor {
  overflow: auto;
  min-height: 8rem;
  max-height: 15rem;
  background: white;
}
</style>
